import { useParams } from "react-router-dom";

export type StatsScope = {
  type: "store" | "chain";
  id: string;
};

export const useStatsScope = (): StatsScope | null => {
  const { storeId, chainId } = useParams<{
    storeId?: string;
    chainId?: string;
  }>();
  if (chainId) {
    return { type: "chain", id: chainId };
  }
  if (storeId) {
    return { type: "store", id: storeId };
  }
  return null;
};

export const statsPath = (scope: StatsScope): string =>
  scope.type === "store" ? `stores/${scope.id}` : `chains/${scope.id}`;
